var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHiddenPanel = function SvgHiddenPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M6.389 19.5h15.222c.491 0 .889.398.889.889v2.222a.89.89 0 0 1-.889.889H6.389a.89.89 0 0 1-.889-.889v-2.222c0-.491.398-.889.889-.889Z"
  })));
};
export default SvgHiddenPanel;